export default {
  // INTERNAL: 1,
  // EXTERNAL: 2,
  CHAT: 1,
  CALL: 2,
  VIDEOCALL: 3,
};
